import React from 'react';

const ProlongedFasting = () => {
  return (
    <div className="prolonged-fasting-page">
      <h1>Prolonged Fasting</h1>
      <p>Welcome to the Prolonged Fasting section of Wholeness Forward.</p>

      <p>
        Prolonged fasting involves fasting for an extended period, typically ranging from 24 hours to several days. This type of fasting is often used to promote deeper cellular repair, metabolic reset, and even spiritual or mental clarity. It is a more advanced fasting technique and requires careful planning and consideration to ensure safety and effectiveness.
      </p>
      <p>
        Research has shown that prolonged fasting can have significant health benefits, such as promoting autophagy (the body’s process of cleaning out damaged cells), improving insulin sensitivity, and reducing inflammation. However, prolonged fasting is not suitable for everyone and should only be done under medical supervision or after consulting a healthcare professional.
      </p>

      <hr />

      <h2>Benefits of Prolonged Fasting</h2>
      <ul>
        <li>Enhances autophagy, aiding in cellular repair and regeneration</li>
        <li>Promotes fat burning and ketosis</li>
        <li>Improves insulin sensitivity and metabolic health</li>
        <li>Reduces inflammation and oxidative stress</li>
        <li>Supports mental clarity and focus</li>
        <li>May increase lifespan and support overall longevity</li>
      </ul>

      <h3>Important Considerations</h3>
      <ul>
        <li>Prolonged fasting can be challenging and should be approached with caution.</li>
        <li>Stay hydrated with water, herbal tea, or electrolytes to prevent dehydration.</li>
        <li>Listen to your body and break your fast if you feel unwell or experience adverse effects.</li>
        <li>Avoid prolonged fasting if you have underlying health conditions or are pregnant.</li>
        <li>Plan your refeeding period carefully to avoid overwhelming your digestive system.</li>
      </ul>

      <hr />

      <h2>Educational Videos on Prolonged Fasting</h2>
      <p>Learn more about prolonged fasting with these informative videos.</p>

      {/* First Video */}
      <div>
        <h3>How to Do a Prolonged Fast</h3>
        <p>
          <strong>Source:</strong> Dr. Mindy Pelz <br />
          <strong>Length:</strong> 10:32 <br />
          Learn the science and strategies behind prolonged fasting, and how to do it safely and effectively.
        </p>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/NvC4QotxpV4"
          title="How to Do a Prolonged Fast"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <hr />

      {/* Second Video */}
      <div>
        <h3>The Science of Prolonged Fasting</h3>
        <p>
          <strong>Source:</strong> Dr. Rhonda Patrick <br />
          <strong>Length:</strong> 15:48 <br />
          This video dives into the science behind prolonged fasting and its impact on the body, including autophagy and cellular rejuvenation.
        </p>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/V33GIiZFlSc"
          title="The Science of Prolonged Fasting"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <hr />

      <h3>Community Prolonged Fasting Discussion</h3>
      <p>
        Join the conversation with others exploring prolonged fasting. Share your experiences, ask questions, and learn from others who practice this advanced fasting technique.
      </p>
      <a href="/forum/prolonged-fasting" className="btn">Join the Forum</a>
    </div>
  );
};

export default ProlongedFasting;
